import { useEffect, useState } from 'react';
import {
  DEFAULT_STATUS_OPTIONS_MAP,
  DEFAULT_STATUS_OPTIONS_RAW_MAP,
  RawStatusOptionsMap,
  StatusOptionsMap,
} from '../config/status-options';
import orderStatusOptionsService from '../services/order-status-options';

interface UseOrderStatusOptionsResult {
  loading: boolean;
  rawMap: RawStatusOptionsMap;
  formattedMap: StatusOptionsMap;
}

/**
 * 加载订单状态选项配置，失败时回退到前端默认配置。
 */
export default function useOrderStatusOptions(): UseOrderStatusOptionsResult {
  const [loading, setLoading] = useState(true);
  const [rawMap, setRawMap] = useState<RawStatusOptionsMap>(DEFAULT_STATUS_OPTIONS_RAW_MAP);
  const [formattedMap, setFormattedMap] = useState<StatusOptionsMap>(DEFAULT_STATUS_OPTIONS_MAP);

  useEffect(() => {
    let active = true;

    orderStatusOptionsService.get().then((payload) => {
      if (!active) {
        return;
      }

      setRawMap(payload.raw_map);
      setFormattedMap(payload.formatted_map);
    }).finally(() => {
      if (active) {
        setLoading(false);
      }
    });

    return () => {
      active = false;
    };
  }, []);

  return {
    loading,
    rawMap,
    formattedMap,
  };
}
